module.exports = __webpack_public_path__ + "img/ad.a58027d8.svg";